export default __webpack_public_path__ + "static/media/device_ie_node_suspended.aa1855a7.svg";